import {AppRegistry} from 'react-native';

import App from './App';

AppRegistry.registerComponent('CameriereDigitaleMini', () => App);

AppRegistry.runApplication('CameriereDigitaleMini', {
  rootTag: document.getElementById('root'),
});
